<section class="partners">

  <h2 class="title">{{ 'our_partners' | translate }}</h2>

  <ngx-slick-carousel
    class="carousel"
    [config]="slideConfig">
    <div ngxSlickItem *ngFor="let partner of partnerLogos; let i = index">
      <div class="partner">
        <div class="media">
          <img [title]="partner.name" [ngSrc]="partner.img" fill alt="Sales trend" />
        </div>
        <div class="partner-text">
          <span>{{ partner.name }}</span>
          <p>{{ partner.desc | translate }}.</p>
          <a [title]="'go_to' | translate" [href]="partner.link" target="_blank">
            <app-button [title]="'go_to' | translate"></app-button>
          </a>
        </div>
      </div>
    </div>
  </ngx-slick-carousel>

  <h2 class="title">{{ 'already_chosen_jecrm' | translate }}</h2>

  <ngx-slick-carousel
    class="carousel"
    [config]="slideConfig">
    <div ngxSlickItem *ngFor="let image of images; let i = index">
      <div class="slide">
        <div class="slide-text">
          <a [title]="image.heading | translate" [href]="image.link" target="_blank">{{ image.heading | translate }}</a>
          <p>{{ image.description | translate }}.</p>
        </div>
        <div class="media">
          <img title="Обрали JECRM" [src]="image.img" alt="Slide-Image" />
        </div>
      </div>
    </div>
  </ngx-slick-carousel>
</section>
